import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SelectionModel } from '@angular/cdk/collections';
import { ServicoLogisticaItem } from '../../../../../../shared/services/responses/vendas/buscar-servicos-logistica.response';

export interface BuscarFretesDialogData {
  servicos: ServicoLogisticaItem[];
  jaAdicionados: string[];
}

@Component({
  selector: 'app-buscar-fretes-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatCheckboxModule,
  ],
  templateUrl: './buscar-fretes-dialog.component.html',
  styleUrl: './buscar-fretes-dialog.component.css',
})
export class BuscarFretesDialogComponent {
  public selection = new SelectionModel<ServicoLogisticaItem>(true, []);

  constructor(
    public dialogRef: MatDialogRef<BuscarFretesDialogComponent, ServicoLogisticaItem[]>,
    @Inject(MAT_DIALOG_DATA) public data: BuscarFretesDialogData
  ) {}

  public isJaAdicionado(servico: ServicoLogisticaItem): boolean {
    return this.data.jaAdicionados.includes(servico.codigo);
  }

  public isAllSelected(): boolean {
    const disponiveis = this.data.servicos.filter(s => !this.isJaAdicionado(s));
    return this.selection.selected.length === disponiveis.length && disponiveis.length > 0;
  }

  public isSomeSelected(): boolean {
    const disponiveis = this.data.servicos.filter(s => !this.isJaAdicionado(s));
    return this.selection.selected.length > 0 && this.selection.selected.length < disponiveis.length;
  }

  public toggleAll(): void {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      const disponiveis = this.data.servicos.filter(s => !this.isJaAdicionado(s));
      this.selection.select(...disponiveis);
    }
  }

  public adicionar(): void {
    this.dialogRef.close(this.selection.selected);
  }

  public cancelar(): void {
    this.dialogRef.close([]);
  }
}
